<template>
  <div class="topdiv">
    <div class="tdiv htmldiv">
      <div class="fr tc6">
        <div class="searchdiv pt20">
          <div class="prelative dinline-block vtop">
            <div class="pinput br5 prelative ofhidden dinline-block bgw tleft" style="box-shadow: none;">
              <input class="input dinline-block" name="" placeholder="请输入关键字" v-model="keyword">
              <router-link class="zbtn pabsolute trans3" :to="'/search?keyword='+keyword"></router-link>
            </div>
          </div>
<!--          <div class="otdiv dinline-block vtop mt5 ml10 lh16">-->
<!--            <a href="" class="ot vtop dinline-block fs16 tc6 pl35 mr5">微视频</a>-->
<!--            <a href="" class="ot vtop dinline-block fs16 tc6 pl35 mr5">航拍</a>-->
<!--            <a href="" class="ot vtop dinline-block fs16 tc6 pl35 mr5">直播</a>-->
<!--          </div>-->
        </div>

<!--        <div class="mt10 tright">-->
<!--          {{hello}} 今天是：<span>{{today}}&nbsp;&nbsp;&nbsp;&nbsp;{{week}}</span>-->
<!--        </div>-->

      </div>
      <router-link class="dinline-block vtop mt10" to="/">
        <img src="../assets/images/index_01.png" alt="">
      </router-link>
      <img class="dinline-block vtop mt35" style="margin-left: 145px;" src="../assets/images/top.gif" alt="">
    </div>
    <div class="nav bg-red header">
      <div class="htmldiv nav_main prelative twhite">
        <template v-for="(item,index) in menu">
          <router-link :to="item.to" class="am fs18 twhite dinline-block" v-if="item.type == 1">{{item.name}}</router-link>
          <div class="hav am fs18 dinline-block tcenter cpointer"  v-else-if="item.type == 2">
            {{item.name}}
            <div class="snav tleft prelative bgw">
              <div class="dinline-block vtop">
                <img class="trans dinline-block vcenter" :src="require('../../static/images/'+item.img)" alt="" width="145" height="140">
                <div class="kh ml25 tc-red fs16 dinline-block vcenter">
                  {{item.introduce}}
                </div>
              </div>
              <div class="alist dinline-block vtop">
                <template v-for="(child,index_) in item.children">
                  <router-link :to="{path:child.to,query:{id:index_,pid:index}}" class="hred mr20 mb15 dinline-block vtop">{{child.name}}</router-link>
                </template>
              </div>
            </div>
          </div>
          <div v-else-if="item.type == 9" style="display: none"></div>
          <a :href="item.to" v-else>{{item.name}}</a>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Top",
  data(){
    return {
      menu:[],
      keyword:'',
      hello:'',
      today:'',
      week:'',
      weeks:[
        '星期天',
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六',
      ],
    }
  },
  created() {
    this.menu = this.$params.column;
    var date = new Date();
    if(date.getHours() >= 12){
      this.hello = '下午好！';
    }else{
      this.hello = '上午好！';
    }
    this.week = this.weeks[date.getDay()];
    this.today = this.$request.date('Y年m月d日',date.getTime()/1000);
  },
  mounted() {
    $('.topdiv input').focus(function() {
      var p = $(this).parent();
      var bcolor = p.css('border-color');
      p.css('box-shadow', '0 0 7px ' + bcolor);

    })

    $('.topdiv input').blur(function() {
      $(this).parent().css('box-shadow', 'none');
    })

    $('.topdiv .hav').each(function() {
      var left = parseInt($(this).position().left);
      var wd = 975;
      if (left <= 150)
        $(this).find('.snav').css('left', -left);
      else if (left - 150 + 975 > 1280) {
        $(this).find('.snav').css('left', -(left + 975 - 1280));
      }
    })
  }
}
</script>

<style scoped>
  .topdiv .tdiv{height: 120px;}
  .topdiv .ot:hover{color: #94070a;font-weight: bold;background-position: 0 -1060px;}
  .topdiv .ot:nth-child(2):hover{background-position: 5px -1112px;}
  .topdiv .ot:nth-child(3):hover{background-position: 5px -1166px;}
  .topdiv .ot{background: url(../assets/images/cn1.png) no-repeat 0 -690px;}
  .topdiv .ot:nth-child(2){background-position: 5px -742px;}
  .topdiv .ot:nth-child(3){background-position: 5px -796px;}
  .nav{height: 52px;}
  .nav .am{position: relative;margin-right: 34px;padding: 0 20px;line-height: 52px;}
  .nav .am:last-child{margin-right: 0;}
  .nav .hav:hover::after{opacity: 1;}
  .nav .hav:hover .snav{height: auto;transform: rotate3d(0,0,0,0);z-index: 1000;}
  .nav .hav::after,.nav .snav{transition: all .3s ease-in-out;}
  .nav .hav::after{content: '';opacity: 0;position: absolute;left: 50%;margin-left: -8px;bottom: 0;border: 8px solid transparent;border-bottom: 8px solid #fff;}
  .nav .snav{overflow: hidden;padding: 35px;position: absolute;left: -150px;z-index: 999;width: 975px;height: 0;line-height: 1.4;transform: rotate3d(1,0,0,90deg);
    background: #fff;transform-origin: center top;cursor: default;}
  .nav .kh{width: 180px;line-height: 2.2;}
  .nav .alist{margin-left: 80px;padding: 25px 0 0 0;width: 450px;}
  .nav .alist a:hover{font-weight: bold;}
  .nav .alist a{width: 125px;font-size: 17px;}
</style>



// WEBPACK FOOTER //
// src/components/Top.vue